import React from 'react'
import styled from '@emotion/styled'
import { BNDLogo } from '../svgs/BNDLogo'
import { Link } from '@jelly/ui'
import { useTheme } from 'emotion-theming'

const BndLogoContainer = styled(Link)`
	cursor: pointer;
	display: block;
	height: 55px;
	margin: 10px 0 20px;
	max-width: 170px;
	width: 250px;
`

export function FooterLogoBnd() {
	const {
		colors: { white },
	} = useTheme()
	return (
		<BndLogoContainer href="/">
			<BNDLogo color={white} />
		</BndLogoContainer>
	)
}
